import _ from 'lodash';
import { useMutation, useQuery } from 'react-query';
import {
  CPThemeApi,
  CustomerPortalTheme,
  GetThemeFromWebsitePayload,
} from 'api/customer-portal/theme-api';

export const getAllCpThemesKey = () => 'useGetAllCpThemes';

export const useGetAllCpThemes = () => {
  return useQuery(getAllCpThemesKey(), () => CPThemeApi.getAllThemes());
};

export const useGetCpThemeById = (id: number) => {
  return useQuery(
    ['useGetCpThemeById', id],
    () => CPThemeApi.getThemeById(id),
    { enabled: _.isFinite(id) && id > 0 },
  );
};

export const useGetAvailableGoogleFonts = () => {
  return useQuery('useGetAvailableGoogleFonts', () =>
    CPThemeApi.getAvailableFonts(),
  );
};

export const useGetVariantsForFonts = (family: string) => {
  return useQuery(
    ['useGetVariantsForFonts', family],
    () => CPThemeApi.getVariantsForFonts(family),
    { initialData: { variants: [] as string[] } },
  );
};

export const useCreateCpTheme = () => {
  return useMutation(
    (payload: Omit<CustomerPortalTheme, 'customerPortalThemeId'>) =>
      CPThemeApi.createTheme(payload),
  );
};

export const useGetThemeFromWebsite = () => {
  return useMutation((payload: GetThemeFromWebsitePayload) =>
    CPThemeApi.getThemeFromWebsite(payload),
  );
};

export const useUpdateCpTheme = () => {
  return useMutation(
    (args: {
      payload: Omit<CustomerPortalTheme, 'customerPortalThemeId'>;
      id: number;
    }) => CPThemeApi.updateTheme(args),
  );
};

export const useDeleteCpThemeById = () => {
  return useMutation((id: number) => CPThemeApi.deleteThemeById(id));
};
